import React, { useEffect, useMemo, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  Download,
  File,
  PlusCircle,
  RotateCcw,
  Sliders,
  StopCircle,
  Archive,
  User,
  Calendar,
  Filter,
  Layers,
  FileMinus,
  MapPin,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import { Table } from "antd";
import { purchaseslist } from "../../../core/json/purchaselistdata";
import { setheadertoggle } from "../../../redux/toggle";
import { useDispatch, useSelector } from "react-redux";
import {
  getConsolidatedReportItemwise,
  getSalesReport,
  getSummReportItemwise,
} from "../../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";
import { renderTooltip } from "../../../redux/helper";
import * as XLSX from "xlsx";
import { Checkbox } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { DatePicker } from "antd";
// import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import {
  fetchCounter,
  fetchSection,
  fetchUserRole,
} from "../../../redux/userSetting";
import { fetchUser } from "../../../redux/userServices";
import {
  exportPDF,
  exportExcel,
  printReport,
} from "../../../core/utils/StockReportUtils";

import LoadingUtils from "../../../core/utils/LoadingUtils";
import { getZoneList } from "../../../services/MasterApiServices"; // Adjust path as needed

const SalesItemSummary = () => {
  const [searchText, setSearchText] = useState("");
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [modifiedList, setModifiedList] = useState();
  const [itemwiseData, setitemwiseData] = useState();
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [totalcount, settotalcount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const tableRef = useRef(null);
  const [groupList1, setGroupList] = useState([]);
  const [productval, setproductval] = useState();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [categoryval, setscategoryval] = useState();
  const [zoneName, setZone] = useState(null);
  const [zoneOptions, setZoneOptions] = useState([]);
const [selectedColumns, setSelectedColumns] = useState([]);


  const { productList, categoryList, groupList } =
    useSelector((state) => state.usersetting);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
  useEffect(() => {
    handleReportList(currentPage, pageSize);
    // handleFilter();
    //handlegetsalesfullReport();
  }, [branch, fromDate, toDate]);

  const handleReportList = async (page, size) => {
    setloading(true);
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    Filters.PaymentType = "";
    Filters.Waiter = "";
    Filters.Counter = "";
    Filters.Section = "";
    Filters.Group = selectedGroup?.value || "";
    Filters.Product = productval?.value || "";
    Filters.Category = categoryval?.value || "";

    try {
      const response = await getSummReportItemwise({
        DatatablePagingParameters,
        Filters,
      });
      setitemwiseData(response?.data?.itemWiseSalesReportDetail);

      const groupedData = [];
      const groupMap = new Map();
      response?.data?.itemWiseSalesReportDetail.forEach((item) => {
        const productName = item.product?.name || "Unknown Product";
        const groupName = item.product?.group?.name || "Unknown Group";
        const categoryName = item.product?.category?.name || "Uncategorized";
        const quantity = item.quantity || 0;
        const total = item.total || 0;
        const counter = item.counter?.name || "Unknown Counter";
const zoneName = item.zoneName || ""; 

        if (!groupMap.has(productName)) {
          const newGroup = {
            products: productName,
            groupName: groupName,
            categoryName: categoryName,
            quantity: 0,
            total: 0,
            counter: counter,
                 zoneName: zoneName,
          };
          groupMap.set(productName, newGroup);
          groupedData.push(newGroup);
        }

        const group = groupMap.get(productName);
        group.quantity += quantity;
        group.total += total;
      });

      console.log(groupedData, "result");
      setitemwiseData(groupedData);
      console.log("groupedData", groupedData);

      setModifiedList(groupedData);
      settotalcount(
        response?.data?.itemWiseSalesReportDetail[0]?.recordsFilteredCount || 0
      );
      setloading(false);
    } catch (error) {
      console.error(
        "Error Fetching Account Type!",
        error.response.data.Message
      );
      setloading(false);
    }
  };
  const product = productList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const category = categoryList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const group = groupList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  let filteredData = itemwiseData?.filter((obj) => {
    const searchMatch = Object?.values(obj)?.some(
      (val) =>
        typeof val === "string" &&
        val.toLowerCase().includes(searchText?.toLowerCase() || "")
    );

    const productMatch =
      !productval || obj.products?.toLowerCase() === productval?.label?.toLowerCase();
    const categoryMatch =
      !categoryval || obj.categoryName?.toLowerCase() === categoryval?.label?.toLowerCase();
    const groupMatch =
      !selectedGroup || obj.groupName?.toLowerCase() === selectedGroup?.label?.toLowerCase();
    const zoneMatch =
      !zoneName || obj.zoneName === zoneName.label; // Compare as string

    return searchMatch && productMatch && categoryMatch && groupMatch && zoneMatch;
  });

  const totalQuantity = filteredData?.reduce(
    (sum, record) => sum + record.quantity,
    0
  );
  const totalTotal = filteredData?.reduce(
    (sum, record) => sum + record.total,
    0
  );

  const footerTotals = {
    quantity: totalQuantity?.toFixed(0) || 0.0,
    total: totalTotal?.toFixed(3) || 0.0,
  };


  const menuItems = [
    { value: "1", label: "Product", checked: true },
    { value: "2", label: "Group Name", checked: true },
    { value: "3", label: "Category", checked: true },
    { value: "4", label: "Quantity", checked: true },
    { value: "5", label: "Amount", checked: true },
    { value: "6", label: "Counter", checked: false },
    { value: "7", label: "Zone", checked: true }, // Add Zone to menuItems
  ];

  const columns = [
    {
      title: "Product",
      key: "1",
      dataIndex: "products",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Group Name",
      key: "2",
      dataIndex: "groupName",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Category",
      key: "3",
      dataIndex: "categoryName",
    },
    {
      title: "Quantity",
      key: "4",
      dataIndex: "quantity",
    },
    {
      title: "Amount",
      key: "5",
      dataIndex: "total",
    },
    {
      title: "Counter",
      key: "6",
      dataIndex: "counter",
    },
    {
      title: "Zone",
      key: "7",
      dataIndex: "zoneName",
      render: (text) => <span>{text}</span>,
    },
  ];

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleFromDateChange = (date) => {
    setFromDate(date);

    setToDate(null);
  };
  const handleToDateChange = (date) => {
    setToDate(date);
  };
  const getActiveTabData = () => {
    let fieldMapping = {};

    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex;
      });
      return mappings;
    };

    fieldMapping = createfieldMapping(selectedColumns);

    return {
      data: filteredData,
      columns: selectedColumns,
      fieldMapping,
      Rname: "Sales Item Summary",
    };
  };
  function handleReset() {
    setFromDate(dayjs());
    setToDate(dayjs());
    setSearchText("");
    setproductval(null);
    setscategoryval(null);
    setSelectedGroup(null);
    setZone("");
  }

  useEffect(() => {
    // Set default selected columns based on menuItems' checked status
    const initialSelectedColumns = menuItems
      ?.filter((item) => item.checked)
      .map((item) => columns.find((col) => col.key === item.value));

    setSelectedColumns(initialSelectedColumns);
  }, []);

  const handleCheckboxChange = (columnKey, checked) => {
    if (checked) {
      // Add column if checkbox is checked
      setSelectedColumns((prevColumns) => {
        const updatedColumns = [
          ...prevColumns,
          columns.find((col) => col.key === columnKey),
        ];

        // Sort the array by col.key in ascending order
        return updatedColumns.sort((a, b) => (a.key > b.key ? 1 : -1));
      });
    } else {
      // Remove column if checkbox is unchecked
      setSelectedColumns((prevColumns) =>
        prevColumns?.filter((col) => col.key !== columnKey)
      );
    }
  };

  const handleRefresh = () => {
    handleReportList(currentPage, pageSize);
  };

  useEffect(() => {
    // Fetch zones on mount
    getZoneList().then((response) => {
      const formattedZones = (response || []).map((zone) => ({
        value: zone.name,
        label: zone.name,
      }));
      setZoneOptions(formattedZones);
    });
  }, []);
console.log("zoneOptions", zoneOptions);
console.log("zoneName", zoneName);
  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Sales Item Summary Report</h4>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <button
                    onClick={() =>
                      exportPDF(
                        getActiveTabData,
                        footerTotals,
                        "Sales Item Summary Report"
                      )
                    }
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <button
                    onClick={() =>
                      exportExcel(
                        getActiveTabData,
                        footerTotals,
                        "Sales Item Summary Report"
                      )
                    }
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel-icon"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <button
                    onClick={() =>
                      printReport(
                        getActiveTabData,
                        footerTotals,
                        "Sales Item Summary Report"
                      )
                    }
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={() => renderTooltip("Refresh")}
                >
                  <Link onClick={handleRefresh}>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div
                      id="DataTables_Table_0_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        {" "}
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-blocks mr-2">
                      <label htmlFor="from-date">From Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="datetimepicker"
                          id="from-date"
                          placeholderText="From Date"
                          selected={fromDate}
                          value={fromDate}
                          onChange={handleFromDateChange}
                          startDate={fromDate}
                          selectsStart
                          dateFormat="dd/MM/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-blocks mr-2">
                      <label htmlFor="to-date">To Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          id="to-date"
                          placeholderText="To Date"
                          value={toDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          startDate={fromDate}
                          selectsEnd
                          disabled={!fromDate}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <div className="input-blocks me-2">
                    <Link
                      className="btn btn-filters ms-auto"
                      onClick={() => {
                        setCurrentPage(1);
                        setPageSize(20);
                        handleReportList(currentPage, pageSize);
                        // handlegetsalesReport(currentPage, pageSize);
                      }}
                    >
                      <i data-feather="search" className="feather-search" />{" "}
                      search{" "}
                    </Link>
                  </div>
                  <div className="input-blocks">
                    <button
                      className="btn btn-reset rounded-2"
                      onClick={handleReset}
                    >
                      <i
                        data-feather="refresh-cw"
                        className="feather-refresh-cw"
                      />{" "}
                      Reset
                    </button>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                    onClick={toggleFilterVisibility}
                  >
                    <Filter className="filter-icon" />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
                <div className="dropdown">
                  <button
                    className="btn  dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Sliders className="info-img" />
                  </button>
                  <ul className="dropdown-menu p-2">
                    {menuItems?.map((obj, i) => {
                      return (
                        <li key={i}>
                          <Checkbox
                            onChange={(e) =>
                              handleCheckboxChange(obj.value, e.target.checked)
                            }
                            defaultChecked={obj.checked}
                          >
                            <div style={{ color: "black" }}> {obj.label}</div>
                          </Checkbox>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Layers className="info-img" />
                        <Select
                          className="img-select"
                          options={product}
                          value={productval}
                          onChange={setproductval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Product"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <FileMinus className="info-img" />
                        <Select
                          className="img-select"
                          options={category}
                          value={categoryval}
                          onChange={setscategoryval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Category"
                        />
                      </div>
                    </div>

                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <FileMinus className="info-img" />
                        <Select
                          className="img-select"
                          options={group}
                          value={selectedGroup}
                          onChange={(e) => setSelectedGroup(e)}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Group"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <MapPin className="info-img" />
                        <Select
                          className="img-select"
                          options={zoneOptions}
                          value={zoneName}
                          onChange={setZone}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Zone"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* /Filter */}
              {selectedColumns && (
                <div className="table-responsive product-list">
                  <Table
                    columns={selectedColumns}
                    dataSource={filteredData}
                    ref={tableRef}
                    id="table-to-export"
                    pagination={{
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${totalcount} items`,
                      current: currentPage,
                      // pageSize: pageSize,
                      total: filteredData?.length, // Total records count
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                        handleReportList(page, size);
                      },
                    }}
                    summary={() => (
                      <Table.Summary.Row>
                        {selectedColumns?.map((col) => (
                          <Table.Summary.Cell key={col.dataIndex}>
                            <b>{footerTotals[col.dataIndex] || ""}</b>
                          </Table.Summary.Cell>
                        ))}
                      </Table.Summary.Row>
                    )}
                  />
                </div>
              )}
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
    </div>
  );
};
export default SalesItemSummary;
